import {Component} from 'react'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Table from '@mui/material/Table'
import TableHead from '@mui/material/TableHead'
import TableContainer from '@mui/material/TableContainer'
import TableRow from '@mui/material/TableRow'
import TableCell from '@mui/material/TableCell'
import Card from '@mui/material/Card'
import CardActions from '@mui/material/CardActions'
import CardContent from '@mui/material/CardContent'
import FormLabel from '@mui/material/FormLabel'
import FormControl from '@mui/material/FormControl'
import Grid from '@mui/material/Grid'
import InputLabel from '@mui/material/InputLabel'
import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import TextField from '@mui/material/TextField'

function Row(props) {
    var item = props.item
    var eventSelect = props.eventSelect
    var eventDelete = props.eventDelete

    return(
        <TableRow>
            <TableCell>{item.tipoReciclador}</TableCell>
            <TableCell>{item.protocolo}</TableCell>
            <TableCell>{item.puerto}</TableCell>
            <TableCell>{item.velocidad}</TableCell>
            <TableCell>{item.archivo}</TableCell>
            <TableCell>{item.debug}</TableCell>
            <TableCell>{item.estado}</TableCell>
            <TableCell>
                <Button variant="contained" size='small' fullWidth onClick={() => {eventSelect(item)}}>Seleccionar</Button>
                <Button variant="contained" size='small' color="error" fullWidth onClick={() => {eventDelete(item)}}>Borrar</Button>
            </TableCell>
        </TableRow>
    )
}

// Reciclador de BILLETES por eSSP (ITL NV4000 multi-modulo o ITL SMART Payout de un cajon). Acepta billetes Y los dispensa,
// reciclando lo aceptado y mandando a la caja lo que no se recicla. Lee su tabla de
// denominaciones del propio equipo (SETUP_REQUEST) -> aqui solo se configura la conexion.
class TabRecicladorBilletes extends Component {
    constructor(props) {
        super(props)

        var tipoDispositivo = props.tipoDispositivo
        var dispositivos = props.dispositivos
        this.guardarEvent = props.event

        this.state = {
            tipoDispositivo: tipoDispositivo,
            dispositivos: dispositivos,
            itemEdicion: null,
            cmbTiposReciclador: 0,
            cmbProtocolos: 0,
            cmbVelocidades: 0,
            cmbDebugs: 0,
            txtPuerto: "",
            txtArchivo: "",
            cmbEstados: 0,
            tiposReciclador: [
                "NV4000",
                "SMARTPAYOUT"
            ],
            protocolos: [
                "eSSP"
            ],
            velocidades: [
                "9600",
                "115200"
            ],
            debugs: [
                "1",
                "2",
                "3",
                "4"
            ],
            estados: [
                {nombre: "Activo", valor: "A"},
                {nombre: "Inactivo", valor: "I"}
            ],
            modoEdicion: false
        }
    }

    onChangecmbTiposReciclador = (event) => {
        this.setState({cmbTiposReciclador: event.target.value})
    }

    onChangecmbProtocolos = (event) => {
        this.setState({cmbProtocolos: event.target.value})
    }

    onChangecmbVelocidades = (event) => {
        this.setState({cmbVelocidades: event.target.value})
    }

    onChangecmbDebugs = (event) => {
        this.setState({cmbDebugs: event.target.value})
    }

    onChangetxtPuerto = (event) => {
        this.setState({txtPuerto: event.target.value.toString()})
    }

    onChangetxtArchivo = (event) => {
        this.setState({txtArchivo: event.target.value.toString()})
    }

    onChangecmbEstados = (event) => {
        this.setState({cmbEstados: event.target.value})
    }

    btnSeleccionarClick = (item) => {
        this.setState({
            itemEdicion: item,
            cmbTiposReciclador: item.tipoReciclador,
            cmbProtocolos: item.protocolo,
            txtPuerto: item.puerto,
            cmbVelocidades: item.velocidad,
            cmbDebugs: item.debug,
            txtArchivo: item.archivo,
            cmbEstados: item.estado,
            modoEdicion: true
        })
    }

    btnBorrarClick = (item) => {
        if(window.confirm("¿Borrar dispositivo?")) {
            this.prepararNuevo()
            var dispositivos = this.state.dispositivos

            var x = dispositivos.indexOf(item)
            if(x >= 0) dispositivos.splice(x, 1)

            this.setState({
                dispositivos: dispositivos
            })

            this.guardarEvent(this.state.tipoDispositivo, this.state.dispositivos, this.confirmacionGuardado)
        }
    }

    btnGuardarClick = () => {
        var dispositivos = this.state.dispositivos

        var item = {
            tipoReciclador: this.state.cmbTiposReciclador,
            protocolo: this.state.cmbProtocolos,
            puerto: this.state.txtPuerto,
            velocidad: this.state.cmbVelocidades,
            debug: this.state.cmbDebugs,
            archivo: this.state.txtArchivo,
            estado: this.state.cmbEstados
        }

        if(this.state.modoEdicion) {
            var x = dispositivos.indexOf(this.state.itemEdicion)
            if(x >= 0) dispositivos[x] = item
        } else {
            dispositivos.push(item)
        }

        this.setState({
            dispositivos: dispositivos
        })

        this.guardarEvent(this.state.tipoDispositivo, this.state.dispositivos, this.confirmacionGuardado)
    }

    prepararNuevo = () => {
        this.setState({
            itemEdicion: null,
            cmbTiposReciclador: 0,
            cmbProtocolos: 0,
            txtPuerto: "",
            cmbVelocidades: 0,
            cmbDebugs: 0,
            txtArchivo: "",
            cmbEstados: 0,
            modoEdicion: false
        })
    }

    confirmacionGuardado = () => {
        this.prepararNuevo()
    }

    render() {
        const columns = [
            {field: 'Tipo', headerName: 'Tipo', width: 140},
            {field: 'Protocolo', headerName: 'Protocolo', width: 100},
            {field: 'Puerto', headerName: 'Puerto', width: 140},
            {field: 'Velocidad', headerName: 'Velocidad', width: 80},
            {field: 'Archivo', headerName: 'Archivo', width: 120},
            {field: 'Debug', headerName: 'Debug', width: 60},
            {field: 'Estado', headerName: 'Estado', width: 60},
            {field: '', headerName: '', width: 120}
          ]

        return(
            <Box>
                <Grid container xs={12}>
                    <Grid item xs={12}>
                        <Card fullWidth>
                            <CardContent>
                                <h3>Reciclador Billetes</h3>
                                <form>
                                    <FormLabel>Información reciclador de billetes (ITL NV4000 / SMART Payout, eSSP)</FormLabel>
                                    <br />
                                    <Box sx={{fontSize: 13, color: 'text.secondary', mt: 1, mb: 1}}>
                                        El reciclador acepta billetes y los dispensa, reciclando lo aceptado y
                                        mandando a la caja lo que no se recicla. <b>NV4000</b>: 4 módulos de una
                                        denominación cada uno y cassette de recarga. <b>SMARTPAYOUT</b>: un solo cajón
                                        de 80 billetes con hasta 3 denominaciones. Lee su tabla de denominaciones del
                                        propio equipo; solo se configura la conexión. El puerto debe apuntar al
                                        dispositivo real (symlink udev como <b>/dev/nv4000</b>, <b>/dev/smartpayout</b>{" "}
                                        o un <b> /dev/ttyUSBx</b>).
                                    </Box>
                                    <Grid container spacing={2}>
                                        <Grid item xs={4}>
                                            <FormControl fullWidth component="fieldset">
                                            <InputLabel>Tipo</InputLabel>
                                            <Select
                                                label="Tipo"
                                                value={this.state.cmbTiposReciclador}
                                                defaultValue={0}
                                                onChange={this.onChangecmbTiposReciclador}>
                                                <MenuItem value={0}>-- Seleccione Tipo --</MenuItem>
                                                {this.state.tiposReciclador.map(item => (
                                                <MenuItem value={item}>{item}</MenuItem>
                                                ))}
                                            </Select>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <FormControl fullWidth component="fieldset">
                                            <InputLabel>Protocolo</InputLabel>
                                            <Select
                                                label="Protocolo"
                                                value={this.state.cmbProtocolos}
                                                defaultValue={0}
                                                onChange={this.onChangecmbProtocolos}>
                                                <MenuItem value={0}>-- Seleccione Protocolo --</MenuItem>
                                                {this.state.protocolos.map(item => (
                                                <MenuItem value={item}>{item}</MenuItem>
                                                ))}
                                            </Select>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <FormControl fullWidth component="fieldset">
                                            <TextField
                                            label="Puerto"
                                            id="outlined-basic"
                                            variant="outlined"
                                            value={this.state.txtPuerto}
                                            onChange={this.onChangetxtPuerto}
                                            fullWidth
                                            />
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <FormControl fullWidth component="fieldset">
                                            <InputLabel>Velocidad</InputLabel>
                                            <Select
                                                label="Velocidad"
                                                value={this.state.cmbVelocidades}
                                                defaultValue={0}
                                                onChange={this.onChangecmbVelocidades}>
                                                <MenuItem value={0}>-- Seleccione Velocidad --</MenuItem>
                                                {this.state.velocidades.map(item => (
                                                <MenuItem value={item}>{item}</MenuItem>
                                                ))}
                                            </Select>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <FormControl fullWidth component="fieldset">
                                            <InputLabel>Debug</InputLabel>
                                            <Select
                                                label="Debug"
                                                value={this.state.cmbDebugs}
                                                defaultValue={0}
                                                onChange={this.onChangecmbDebugs}>
                                                <MenuItem value={0}>-- Seleccione Debug --</MenuItem>
                                                {this.state.debugs.map(item => (
                                                <MenuItem value={item}>{item}</MenuItem>
                                                ))}
                                            </Select>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <FormControl fullWidth component="fieldset">
                                            <TextField
                                            label="Archivo"
                                            id="outlined-basic"
                                            variant="outlined"
                                            value={this.state.txtArchivo}
                                            onChange={this.onChangetxtArchivo}
                                            fullWidth
                                            />
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <FormControl fullWidth component="fieldset">
                                            <InputLabel>Estado</InputLabel>
                                            <Select
                                                label="Estado"
                                                value={this.state.cmbEstados}
                                                defaultValue={0}
                                                onChange={this.onChangecmbEstados}>
                                                <MenuItem value={0}>-- Seleccione estado --</MenuItem>
                                                {this.state.estados.map(item => (
                                                <MenuItem value={item.valor}>{item.nombre}</MenuItem>
                                                ))}
                                            </Select>
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </form>
                            </CardContent>
                            <CardActions>
                                <Button  variant="contained" onClick={this.btnGuardarClick}>{ this.state.modoEdicion  === true ? "Modificar": "Agregar"}</Button>
                                <Button  variant="contained" onClick={this.prepararNuevo}>Cancelar</Button>
                            </CardActions>
                        </Card>
                    </Grid>
                </Grid>
                <br />
                <Card xs={8}>
                    <CardContent xs={8}>
                        <TableContainer xs={8}>
                            <Table stickyHeader class="table-data" xs={8}>
                                <TableHead>
                                    <TableRow>
                                        {
                                            columns.map((column) => {
                                                return(
                                                    <TableCell style={{width: column.width}} key={column.field}>{column.headerName}</TableCell>
                                                )
                                            })
                                        }
                                    </TableRow>
                                </TableHead>
                                {
                                    this.state.dispositivos.map((dispositivo) => {
                                        return(<Row item = {dispositivo} eventSelect={this.btnSeleccionarClick} eventDelete={this.btnBorrarClick} />)
                                    })
                                }
                            </Table>
                        </TableContainer>
                    </CardContent>
                </Card>
            </Box>
        )
    }
}

export default TabRecicladorBilletes
